"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECustomerStatus = void 0;
var ECustomerStatus;
(function (ECustomerStatus) {
    ECustomerStatus["ACTIVE"] = "active";
    ECustomerStatus["INACTIVE"] = "inactive";
})(ECustomerStatus || (exports.ECustomerStatus = ECustomerStatus = {}));
